import * as wooutils from "./utils.js";
import * as tracking from "../tracking.js";

export function init() {

    //  console.log("cart init");
    // jQuery(".product-remove a").on("click", function (e) {

    //     e.stopPropagation();
    //     var cart_item = jQuery(this).attr("data-cart_item_key");
    //     console.log("remove cart_item: ", cart_item);
    //     wooutils.remove_from_cart(cart_item);
    // });


    jQuery(".single_add_to_cart_button").on("click", function () {
        gtm_addtocart()
    });

    jQuery(".add_to_cart_button").on("click", function () {
        gtm_addtocart()
    });

    /*****REMOVE FROM SHOPPING CART */
    jQuery(".minicart").on("click", ".remove_from_cart_button", function (e) {
        e.stopPropagation();
        var cart_item = jQuery(this).attr("data-cart_item_key");
        console.log("remove from cart: " + cart_item);

        wooutils.remove_from_cart(cart_item);
    });
}


export function refreshCart() {
    if (jQuery("body").hasClass("woocommerce-cart")) {
        jQuery(".woocommerce-shipping-totals .woocommerce-shipping-destination").html(jQuery(".woocommerce-shipping-totals .woocommerce-shipping-destination").html().replace("Shipping to", ""));
    }
}

function gtm_addtocart() {
    var product_name = jQuery(".product_title").attr("data-product_name");
    var product_variation = jQuery(".product_title").attr("data-product_variation");
    var product_price = jQuery(".product_title").attr("data-product_price");
    var product_sku = jQuery(".product_title").attr("data-product_variation");
    var qty = jQuery(this).closest("input[name=quantity]").val();

    var data = {
        event: "add_to_cart",
        eventLabel: "Add to Cart",
        eventCategory: "Add to Cart",
        eventAction: "Add to Cart",
        ecommerce: {
            "items": [{
                "item_id": product_sku,
                "item_name": product_name,
                "price": product_price,
                "quantity": qty,
                "item_variant": product_variation,

            }]
        }

    }

    tracking.pushtodatalayer(data);

    // console.log("pushing data to datalayer", data);
    // window.dataLayer = window.dataLayer || []; // get or set the dataLayer
    // dataLayer.push(data);
}
